export default function ($http, discrepancyResolvedState) {
    return function (vehicleId) {
        return $http.get(`api/vehicles/${ vehicleId }/enquiries/progress`)
                    .then(x => x.data)
                    .then(result => {
                        result.map(x => {
                            x.discrepancies = x.discrepancies.map(discrepancy => {
                                // tranform the enum: value -> repository
                                discrepancy.resolvedState = discrepancyResolvedState[discrepancy.resolvedState];

                                return discrepancy;
                            });

                            return x;
                        });

                        return result;
                    });
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/enquiries/getEnquiriesProgress.js